import React from "react";

const cards = [
    {
        image: "/img/home_3_1.png",
        title: "Zaplecze GO-Leasing",
        text: "Korzystasz z doświadczenia dużej sieci doradców, partnerów i finansujących — od wyboru auta po warunki umowy.",
    },
    {
        image: "/img/home_3_2.jpg",
        title: "Obsługa zdalna",
        text: "Wybierasz samochód online, a doradca pomaga sprawdzić ratę, dokumenty i kolejne kroki bez wizyty w oddziale.",
    },
    {
        image: "/img/home_3_3.png",
        title: "Rabaty, GAP i zwrot auta",
        text: "Przy wybranych autach sprawdzisz rabaty, ubezpieczenie, GAP oraz finansowanie z opcją zwrotu samochodu.",
    },
];

function HomeCards() {
    return (
        <section className="home-cards-section">
            <div className="container">
                <div className="home-cards-grid">
                    {cards.map((card, i) => (
                        <div key={i} className="home-card">
                            <div className="home-card-img">
                                <img src={card.image} alt={card.title}/>
                            </div>
                            <div className="home-card-body">
                                <h3 className="home-card-title">{card.title}</h3>
                                <p className="home-card-text">{card.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default HomeCards;
